module.exports = __webpack_public_path__ + "img/cooperation2.150fb440.png";